import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Dropdown from "../../components/Dropdown";
import {
  Container,
  Heading,
  FormControl,
  FormLabel,
  Stack,
  Text,
  Flex,
  Radio,
  RadioGroup,
  Select,
  Button,
  useToast,
  Box,
} from "@chakra-ui/react";
import RadioCard from "../../components/candidate/newrequestform/RadioCard";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

const NewRequest13 = () => {
  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const [candidateName, setCandidateName] = useState("");
  const [roles, setRoles] = useState([]);
  const [batteryOptions, setBatteryOptions] = useState([]);
  const [regionalCenters, setRegionalCenters] = useState([]);

  const [formData, setFormData] = useState({
    candidateID: Number(id),
    HbatteryID: null,
    ddjobroleID: "",
    opDepartment: "",
    reqPurpose: "",
    empType: "",
  });

  const getCandidateDets = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getcandidateDets&huserID=${HuserID}&uuid=${UUID}&candidateID=${id}`,
        { method: "GET" }
      );
      const data = await response.json();
      const candidateDets = data[0].candidateDets[0];
      setCandidateName(candidateDets.fname + " " + candidateDets.sname);
    } catch (error) {
      toast({
        title: "Error fetching candidate details",
        description: "There was an error fetching the candidate. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getDDjobRole = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getDDjobRole&huserID=${HuserID}&uuid=${UUID}&HclientID=13`,
        { method: "GET" }
      );
      const data = await response.json();
      setRoles(data || []);
    } catch (error) {
      console.log(error);
      toast({
        title: "Error fetching roles",
        description: "There was an error loading roles. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getBatteryPerRole = async (ddjobroleID) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getBatteryPerJobRole&huserID=${HuserID}&uuid=${UUID}&ddjobroleID=${ddjobroleID}`,
        { method: "GET" }
      );
      const data = await response.json();
      setBatteryOptions(data || []);
      if (data && data.length > 0 && data[0].HbatteryID) {
        setFormData((prev) => ({ ...prev, HbatteryID: data[0].HbatteryID }));
      }
    } catch (error) {
      console.log(error);
      toast({
        title: "Error fetching battery options",
        description: "There was an error loading battery options. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const getRegionalCenters = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}?method=getDepartmentPerClient&huserID=${HuserID}&uuid=${UUID}&HclientID=13`,
        { method: "GET" }
      );
      const data = await response.json();
      setRegionalCenters(data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const postNewRequest = async () => {
    try {
      setLoading(true);
      return await fetch(
        `${API_BASE_URL}?method=addRequest13&huserID=${HuserID}&uuid=${UUID}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
          mode: "no-cors",
        }
      );
    } catch (error) {
      toast({
        title: "Error posting request details",
        description: "There was an error submitting your request. Please try again.",
        status: "error",
        duration: 6000,
        isClosable: true,
      });
    } finally {
      toast({
        title: "Request Submitted!",
        description: `Candidate ${candidateName} now has a request logged`,
        status: "success",
        duration: 6000,
        isClosable: true,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "role") {
      setFormData({ ...formData, ddjobroleID: value });
      setBatteryOptions([]);
      if (value) getBatteryPerRole(value);
      return;
    }

    if (name === "batteryID") {
      setFormData({ ...formData, HbatteryID: value, [name]: value });
      return;
    }

    if (
      name === "opDepartment" ||
      name === "empType" ||
      name === "reqPurpose"
    ) {
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: Number(value) });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.reqPurpose) {
      toast({
        title: "Request Purpose required",
        description: "Please select Recruitment or Development.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
      return;
    }
    postNewRequest();
    setFormData({
      candidateID: Number(id),
      HbatteryID: null,
      ddjobroleID: "",
      opDepartment: "",
      reqPurpose: "",
      empType: "",
    });
  };

  useEffect(() => {
    getCandidateDets();
    getDDjobRole();
    getRegionalCenters();
  }, []);

  return (
    <Container minW="80vw" p={5}>
      <Heading className="text-xl font-bold" mb="12">
        New Request for {candidateName}
      </Heading>

      <form onSubmit={handleSubmit}>
        <FormControl minH="100%" my={12} as="fieldset">
          <Flex direction="row" align="flex-start" gap={8}>
            <Box minW="200px">
              <FormLabel as="legend" fontWeight="bold" mt={2}>
                Select role
              </FormLabel>
              <Select
                name="role"
                value={formData.ddjobroleID}
                onChange={handleChange}
                placeholder="Select a role"
                isRequired
                maxW="200px"
              >
                {roles.map((role) => (
                  <option key={role.ddjobroleID} value={role.ddjobroleID}>
                    {role.roleName}
                  </option>
                ))}
              </Select>
            </Box>

            {formData.ddjobroleID && batteryOptions.length > 0 && (
              <Box flex="1">
                <FormLabel as="legend" fontWeight="bold" mt={2}>
                  Relevant Assessment Battery
                </FormLabel>
                <Flex
                  minH="100%"
                  direction={{ base: "column", lg: "row" }}
                  justify="flex-start"
                  spacing={4}
                  wrap="wrap"
                >
                  {batteryOptions.map((battery) => (
                    <RadioCard
                      isRequired
                      key={battery.allocRequestBatteryID}
                      value={battery.allocRequestBatteryID}
                      isChecked={formData.batteryID === battery.allocRequestBatteryID}
                      handleChange={handleChange}
                      name="batteryID"
                    >
                      <Flex direction="column" justify="space-between" align="left">
                        <Text fontWeight="bold" fontSize="md">
                          {battery.shortdescription}
                        </Text>
                        <Text fontSize="sm" color="gray.600">
                          {battery.longdescription}
                        </Text>
                      </Flex>
                    </RadioCard>
                  ))}
                </Flex>
              </Box>
            )}
          </Flex>
        </FormControl>

        <FormControl my={6}>
          <FormLabel fontWeight="bold">Regional center</FormLabel>
          <Dropdown
            margin="2"
            width="60ch"
            placeHolder="Select Regional center"
            name="opDepartment"
          options={regionalCenters}
          optionKey="HdepartmentID"
          optionDisplay="shortdescription"
          state={formData}
          handleChange={handleChange}
          required={true}
          />
        </FormControl>

        <FormControl mt="8" isRequired>
          <FormLabel fontWeight="bold">Request Purpose</FormLabel>
          <RadioGroup value={formData.reqPurpose || ""}>
            <Stack direction="row">
              <Radio name="reqPurpose" value="recruitment" onChange={handleChange}>
                Recruitment
              </Radio>
              <Radio name="reqPurpose" value="development" onChange={handleChange}>
                Development
              </Radio>
            </Stack>
          </RadioGroup>
        </FormControl>

        <FormControl my={6}>
          <FormLabel fontWeight="bold">Employment Type</FormLabel>
          <Select
            name="empType"
            value={formData.empType}
            onChange={handleChange}
            placeholder="Employment Type"
            isRequired
            maxW="60ch"
          >
            <option>Permanent</option>
            <option>Fixed-Term</option>
            <option>Intern</option>
          </Select>
        </FormControl>

        <Button type="submit" my="12">
          Submit
        </Button>
      </form>
    </Container>
  );
};

export default NewRequest13;
